//// 바텀 시트

// 하단 네비게이션 바 높이
export const NAVIGATION_HEIGHT = 64;
// 바텀시트 상단 드래그 핸들(thumb) 높이
export const BOTTOM_MODAL_SHEET_THUMB_HEIGHT = 24;
// 바텀시트 접힌 상태에서 보이는 영역 높이 (thumb + 네비게이션)
export const BOTTOM_MODAL_SHEET_COLLAPSED_HEIGHT =
	BOTTOM_MODAL_SHEET_THUMB_HEIGHT + NAVIGATION_HEIGHT;
// 바텀시트 펼쳤을 때 화면 상단과의 여백
export const BOTTOM_SHEET_TOP_MARGIN = 20;
// 주유소 선택 시 마커 위치를 계산할 때 사용할 바텀시트 대략 높이
export const SELECTED_STATION_SHEET_HEIGHT = 320;
// 선택된 마커를 항상 가장 위에 보이게 할 z-index
export const SELECTED_STATION_MARKER_Z_INDEX = 10_000;
export const DEFAULT_STATION_MARKER_Z_INDEX = 1;

export const FUEL_TYPE_OPTION = [
	{ label: '휘발유', value: 'B027' },
	{ label: '경유', value: 'D047' },
	{ label: 'LPG', value: 'K015' },
] as const;

export const SNAP_POINTS = [0, BOTTOM_MODAL_SHEET_COLLAPSED_HEIGHT, 0.5, 1];
